import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  grid-template-columns: 50% 20% 30%;
`;

const SubList = ({ name, quantity, counter, amount }) => {
  return (
    <Container>
      <div>
        <Translate id={`checkout.review.${name}`} />
      </div>
      <div>
        {quantity}
        <Translate id={`checkout.review.${counter}`} />
      </div>
      <div>{amount}円</div>
    </Container>
  );
};

export default SubList;
